import api from './api';
import { getTodayISO } from '../utils/dateUtils';

export interface ExportFilters {
  status?: string;
  date_from?: string;
  date_to?: string;
  sales_officer_id?: number;
  brand_id?: number;
  assigned_to?: number;
  company_sales_person?: number;
  source?: string;
  source_empty?: boolean;
  last_call_outcome?: string;
  search?: string;
  next_call_due?: string;
  project_district?: string;
  conversion_status?: string;
  call_date_from?: string;
  call_date_to?: string;
}

export const exportService = {
  export: async (type: 'customers' | 'leads' | 'orders' | 'tenders', filters?: ExportFilters): Promise<void> => {
    const response = await api.get(`/api/export/${type}`, {
      params: filters,
      responseType: 'blob',
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `${type}_export_${getTodayISO()}.csv`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};




